import React from 'react';
import { connect } from 'react-redux';

export function CompleteMessage({ name }) {
  return (
    <div>
      Success! Your username is now '
      {name}
'.
    </div>
  );
}

const mapStateToProps = ({ settings: { data: { name } } }) => ({ name });

export default connect(mapStateToProps)(CompleteMessage);